/**
 * WorkDocTableMenu — Floating table-specific toolbar when cursor is in a table.
 */
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import {
  Table, Rows, Columns, Trash2, Merge, Split,
  ArrowUp, ArrowDown, ArrowLeft as ArrowLeftIcon, ArrowRight,
} from "lucide-react";

export default function WorkDocTableMenu({ editor }) {
  if (!editor || !editor.isActive("table")) return null;

  return (
    <div className="flex items-center gap-1 px-3 py-1.5 bg-blue-900/30 border border-blue-800/40 rounded-t mx-3 mt-2">
      <span className="text-[10px] uppercase tracking-wider text-blue-400 mr-2">Table</span>

      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().addRowBefore().run()}
        className="h-6 px-1.5 text-blue-300 hover:text-white hover:bg-blue-800/40 text-[10px]"
        title="Insert row above"
      >
        <ArrowUp className="w-3 h-3 mr-0.5" /> Row
      </Button>
      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().addRowAfter().run()}
        className="h-6 px-1.5 text-blue-300 hover:text-white hover:bg-blue-800/40 text-[10px]"
        title="Insert row below"
      >
        <ArrowDown className="w-3 h-3 mr-0.5" /> Row
      </Button>
      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().deleteRow().run()}
        className="h-6 px-1.5 text-red-300 hover:text-white hover:bg-red-800/40 text-[10px]"
        title="Delete row"
      >
        <Trash2 className="w-3 h-3 mr-0.5" /> Row
      </Button>

      <Separator orientation="vertical" className="h-4 mx-0.5 bg-blue-800/60" />

      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().addColumnBefore().run()}
        className="h-6 px-1.5 text-blue-300 hover:text-white hover:bg-blue-800/40 text-[10px]"
        title="Insert column left"
      >
        <ArrowLeftIcon className="w-3 h-3 mr-0.5" /> Col
      </Button>
      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().addColumnAfter().run()}
        className="h-6 px-1.5 text-blue-300 hover:text-white hover:bg-blue-800/40 text-[10px]"
        title="Insert column right"
      >
        <ArrowRight className="w-3 h-3 mr-0.5" /> Col
      </Button>
      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().deleteColumn().run()}
        className="h-6 px-1.5 text-red-300 hover:text-white hover:bg-red-800/40 text-[10px]"
        title="Delete column"
      >
        <Trash2 className="w-3 h-3 mr-0.5" /> Col
      </Button>

      <Separator orientation="vertical" className="h-4 mx-0.5 bg-blue-800/60" />

      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().mergeCells().run()}
        className="h-6 px-1.5 text-blue-300 hover:text-white hover:bg-blue-800/40 text-[10px]"
        title="Merge cells"
      >
        <Merge className="w-3 h-3 mr-0.5" />
      </Button>
      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().splitCell().run()}
        className="h-6 px-1.5 text-blue-300 hover:text-white hover:bg-blue-800/40 text-[10px]"
        title="Split cell"
      >
        <Split className="w-3 h-3 mr-0.5" />
      </Button>

      <Separator orientation="vertical" className="h-4 mx-0.5 bg-blue-800/60" />

      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().toggleHeaderCell().run()}
        className="h-6 px-1.5 text-blue-300 hover:text-white hover:bg-blue-800/40 text-[10px]"
        title="Toggle header cell"
      >
        Toggle Header
      </Button>
      <Button
        variant="ghost" size="sm"
        onClick={() => editor.chain().focus().deleteTable().run()}
        className="h-6 px-1.5 text-red-300 hover:text-white hover:bg-red-800/40 text-[10px]"
        title="Delete table"
      >
        <Trash2 className="w-3 h-3 mr-0.5" /> Table
      </Button>
    </div>
  );
}
